export default __webpack_public_path__ + "static/media/WarHood1.8003d2f1.pdf";